import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';

const PackSummary: FunctionComponent = () => {
  return <Box data-cy="PackSummary">PackSummary</Box>;
};

export default PackSummary;
